import Service from "./Service"


export default class ReviewService extends Service {
    constructor() {
        super()
        this.serviceUrl = `https://api.travelski.com/catalog-manager/review`
        this.mandatoryFields = {
            "getRateByLihe": ['liheId', "locale"],
        }
        
    }


    async getRateByLihe(requestData) {
        this.checkMandatoryFields(requestData, "getRateByLihe")
        const {
            liheId,
            averageRatingMin,
            averageRatingMax,
            locale,
            start,
            size,
            sortFields,
            sortDirs,
        } = requestData
        const headers = {
            "x-api-key": 'EYqj93IyuTaefOlYXfBYAClXMt8Rntr59vPev8G3',
        }
        const params = {
            averageRatingMin,
            averageRatingMax,
            start,
            size,
            sortFields,
            sortDirs,
        }
        const url = `${this.serviceUrl}/rate/byLihe/${liheId}`
        const {
            data
        } = await this.axios.get(url, {
            params,
            headers
        })
        return data
    }


}